import React, { Component } from "react";
import "./../css/modal.css";

class Modal extends Component {
	render() {
		const display = !this.props.open ? "none" : "block";
		return (
			<div className="modal-bg" style={{ display: display }}>
				<div className="modal-inner-dialog">
					<div className="modal-header-dialog">
						<label>{this.props.title}</label>
						<button className="close" onClick={this.props.onCloseModal}>
							X
						</button>
					</div>
					{this.props.children}
				</div>
			</div>
		);
	}
} 
export default Modal;
